import axios from 'axios'

const testing = process.env.NODE_ENV === 'test'
const apiVersion = 'v1'
const env = process.env.NODE_ENV
let baseDomain

// Production is default
switch (env) {
  case 'development':
    baseDomain = 'http://localhost:9292'
    break
  case 'staging':
    baseDomain = 'https://apiqa.dineoncampus.com'
    break
  default:
    baseDomain = 'https://api.dineoncampus.com'
}

const baseURL = `${baseDomain}/${apiVersion}/`

function ResponseError(response) {
  this.response = response.data
}

let DefaultPublicAPI = {}
if (testing === true) {
  DefaultPublicAPI = axios
} else {
  DefaultPublicAPI = axios.create({
    baseURL,
    timeout: 20000,
    headers: { 'Content-Type': 'application/json' },
  })
}

// Add a response interceptor
DefaultPublicAPI.interceptors.response.use(
  response => {
    // Do something with response data
    if (response.data.status === 'error') {
      throw new ResponseError(response)
    }
    return response.data
  },
  error => {
    throw new ResponseError(error.response)
  }
)

const PublicAPI = DefaultPublicAPI

export default PublicAPI
